import { applyMask } from "./applyMask.js";
const onlyNonDigitsGlobal = /[^0-9]/g, removeAllNonDigits = (val) => val.replace(onlyNonDigitsGlobal, ""), calcInsert = (opt) => {
  const {
    maskedValueAfter,
    maskedValueBefore,
    selectionStartBefore,
    selectionEndBefore,
    initialMask,
    cursorPositionAfter
  } = opt;
  if (selectionEndBefore == null || selectionStartBefore == null || cursorPositionAfter == null)
    return;
  if (selectionEndBefore > selectionStartBefore && cursorPositionAfter === selectionStartBefore || selectionStartBefore > cursorPositionAfter) {
    const value = initialMask.slice(cursorPositionAfter, selectionEndBefore).replace(/[^0-9ymd]/gi, ""), { maskedValue: maskedValue2 } = applyMask({
      prevMaskedValue: maskedValueBefore,
      insertedValue: value,
      applyFromIndex: cursorPositionAfter
    });
    return {
      cursorPosition: cursorPositionAfter,
      maskedValue: maskedValue2
    };
  }
  const insertedValue = maskedValueAfter.slice(
    selectionStartBefore,
    cursorPositionAfter
  ), stripedNonDigitsSymbolsInsertedValue = removeAllNonDigits(insertedValue), { maskedValue, cursorPosition } = applyMask({
    prevMaskedValue: maskedValueBefore,
    insertedValue: stripedNonDigitsSymbolsInsertedValue,
    applyFromIndex: selectionStartBefore
  });
  return {
    cursorPosition,
    maskedValue
  };
};
export {
  calcInsert
};
//# sourceMappingURL=calcInsert.js.map
